/* eslint-disable function-paren-newline */
import { RouteConfig } from 'vue-router'

import postcodeGuard from '@/router/guards/postcode'
import registrationGuard from '@/router/guards/registration'

const BookingPostcode = () =>
  import(
    /* webpackChunkName: "signup" */
    '@/views/bookingFunnel/CSBookingPostcode.vue'
  )

const BookingSignup = () =>
  import(
    /* webpackChunkName: "signup" */
    '@/views/bookingFunnel/CSBookingSignup.vue'
  )

const CSBookingCGSignup = () =>
  import(
    /* webpackChunkName: "signup" */
    '@/views/bookingFunnel/CSBookingCGSignup.vue'
  )
const CSBookingLongForm = () =>
  import(
    /* webpackChunkName: "signup" */
    '@/views/bookingFunnel/CSBookingLongForm.vue'
  )

const CSReactivateCGCampaignA1  = () =>
  import(
    /* webpackChunkName: "signup" */
    '@/views/bookingFunnel/CSReactivateCGCampaignA1.vue'
  )
const CSReactivateCGCampaignB2  = () =>
  import(
    /* webpackChunkName: "signup" */
    '@/views/bookingFunnel/CSReactivateCGCampaignB2.vue'
  )
const CSReactivateCGCampaignB3  = () =>
  import(
    /* webpackChunkName: "signup" */
    '@/views/bookingFunnel/CSReactivateCGCampaignB3.vue'
  )
const CSReactivateCGConfirmA1  = () =>
  import(
    /* webpackChunkName: "signup" */
    '@/views/bookingFunnel/CSReactivateCGConfirmA1.vue'
  )
const CSReactivateCGCampaignB1  = () =>
  import(
    /* webpackChunkName: "signup" */
    '@/views/bookingFunnel/CSReactivateCGCampaignB1.vue'
  )

const BookingThankYou = () =>
  import(
    /* webpackChunkName: "thankYou" */
    '@/views/bookingFunnel/CSBookingThankYou.vue'
  )
const BookingSuccess = () =>
  import(
    /* webpackChunkName: "thankYou" */
    '@/views/bookingFunnel/CSBookingNewFunel.vue'
  )
const OnlineFunelConfirm = () =>
  import(
    /* webpackChunkName: "thankYou" */
    '@/views/bookingFunnel/CSBookingNewOnlineFunel.vue'
  )
const OnlineFunelConfirm2nd = () =>
  import(
    /* webpackChunkName: "thankYou" */
    '@/views/bookingFunnel/CSBookingNewOnlineFunel2nd.vue'
  )

const postcodeRegistrationRoutes: Array<RouteConfig> = [
  {
    path: '/anfrage',
    name: 'anfrage',
    meta: {
      gtm: 'booking funnel - postcode',
      layout: 'wide',
      translateKey: 'PAGETITLE_GERMAN_POSTCODE',
    },
    component: BookingPostcode,
    beforeEnter: postcodeGuard,
  },
  //Redirects for older links of CU Funnel
  {
    path: '/new-cu-funel/:subPath*', redirect: '/anfrage/registrieren/:subPath*'
  },
  {
    path: '/confirm-new-cu-funel/:subPath*', redirect: '/anfrage/registrieren/bestaetigen/:subPath*'
  },
  //Redirects for older links of CG Funnel
  {
    path: '/new-cg-funnel/:subPath*', redirect: '/alltagshilfe/bewerbung/:subPath*'
  },
  {
    path: '/new-long-form-funnel/:subPath*', redirect: '/alltagshilfe/bewerbung/teil-zwei/:subPath*'
  },
  {
    path: '/confirm-new-online-cg-funel/:subPath*', redirect: '/alltagshilfe/bewerbung/bestaetigen/:subPath*'
  },
  {
    path: '/confirm-2nd-funel/:subPath*', redirect: '/alltagshilfe/bewerbung/bestaetigen-ende/:subPath*'
  },
  {
    path: '/registrieren',
    name: 'registrieren',
    props: route => ({ query: route.query }),
    meta: {
      gtm: 'booking funnel - registration',
      layout: 'wide',
      translateKey: 'PAGETITLE_GERMAN_REGISTRATION',
    },
    component: BookingSignup,
    beforeEnter: registrationGuard,
  },
  {
    path: '/anfrage/registrieren',
    name: 'new-cu-funel',
    props: route => ({ query: route.query }),
    meta: {
      gtm: 'booking funnel - registration',
      layout: 'wide',
      translateKey: 'PAGETITLE_GERMAN_REGISTRATION',
    },
    component: BookingSignup,
  },
  {
    path: '/alltagshilfe/bewerbung',
    name: 'new-cg-funnel',
    props: route => ({ query: route.query }),
    meta: {
      gtm: 'care giver funnel - registration',
      layout: 'wide',
      translateKey: 'PAGETITLE_GERMAN_REGISTRATION',
    },
    component: CSBookingCGSignup,
  },
  {
    path: '/alltagshilfe/bewerbung/teil-zwei',
    name: 'new-long-form-funnel',
    props: route => ({ query: route.query }),
    meta: {
      gtm: 'care giver funnel - registration',
      layout: 'wide',
      translateKey: 'PAGETITLE_GERMAN_REGISTRATION',
    },
    component: CSBookingLongForm,
  },
  {
    path: '/reactivate-cg-a1',
    name: 'reactivate-cg-a1',
    // props: route => ({ query: route.query.postcode }),
    meta: {
      gtm: 'care giver funnel - registration',
      layout: 'wide',
      translateKey: 'PAGETITLE_GERMAN_REGISTRATION',
    },
    component: CSReactivateCGCampaignA1,
  },
  {
    path: '/reactivate-cg-b2',
    name: 'reactivate-cg-b2',
    // props: route => ({ query: route.query.postcode }),
    meta: {
      gtm: 'care giver funnel - registration',
      layout: 'wide',
      translateKey: 'PAGETITLE_GERMAN_REGISTRATION',
    },
    component: CSReactivateCGCampaignB2,
  },
  {
    path: '/reactivate-cg-b3',
    name: 'reactivate-cg-b3',
    // props: route => ({ query: route.query.postcode }),
    meta: {
      gtm: 'care giver funnel - registration',
      layout: 'wide',
      translateKey: 'PAGETITLE_GERMAN_REGISTRATION',
    },
    component: CSReactivateCGCampaignB3,
  },
  {
    path: '/reactivate-confirm-a1',
    name: 'reactivate-confirm-a1',
    // props: route => ({ query: route.query.postcode }),
    meta: {
      gtm: 'care giver funnel - registration',
      layout: 'wide',
      translateKey: 'PAGETITLE_GERMAN_REGISTRATION',
    },
    component: CSReactivateCGConfirmA1,
  },
  {
    path: '/reactivate-cg-b1',
    name: 'reactivate-cg-b1',
    // props: route => ({ query: route.query.postcode }),
    meta: {
      gtm: 'care giver funnel - registration',
      layout: 'wide',
      translateKey: 'PAGETITLE_GERMAN_REGISTRATION',
    },
    component: CSReactivateCGCampaignB1,
  },
  {
    path: '/alltagshilfe/bewerbung/bestaetigen',
    name: 'confirm-new-online-cg-funel',
    // props: route => ({ query: route.query.postcode }),
    meta: {
      gtm: 'booking funnel - registration',
      layout: 'wide',
      // translateKey: 'PAGETITLE_GERMAN_REGISTRATION',
    },
    component: OnlineFunelConfirm,
  },

  {
    path: '/alltagshilfe/bewerbung/bestaetigen-ende',
    name: 'confirm-2nd-funel',
    // props: route => ({ query: route.query.postcode }),
    meta: {
      gtm: 'booking funnel - registration',
      layout: 'wide',
      // translateKey: 'PAGETITLE_GERMAN_REGISTRATION',
    },
    component: OnlineFunelConfirm2nd,
  },
  {
    path: '/anfrage/registrieren/bestaetigen',
    name: 'confirm-new-cu-funel',
    // props: route => ({ query: route.query.postcode }),
    meta: {
      gtm: 'confirm booking funnel - registration',
      layout: 'wide',
      translateKey: 'PAGETITLE_GERMAN_REGISTRATION',
    },
    component: BookingSuccess,
  },
  {
    path: '/login-plz',
    name: 'login-plz',
    meta: {
      showLoginComponent: true,
      gtm: 'booking funnel - login',
      layout: 'wide',
      translateKey: 'PAGETITLE_GERMAN_POSTCODE_PLZ',
    },
    component: BookingSignup,
  },
  {
    path: '/vielen-dank',
    name: 'registration-thank-you',
    component: BookingThankYou,
    meta: {
      gtm: 'registration - thank you page - no caregivers found',
      translateKey: 'PAGETITLE_GERMAN_REGISTRATION_THANKYOU',
      layout: 'main',
    },
  },
]

export default postcodeRegistrationRoutes
